var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15ZM11.1151 11.3071C12.1221 10.3505 12.75 8.99858 12.75 7.5C12.75 4.60051 10.3995 2.25 7.5 2.25C6.70433 2.25 5.95005 2.42699 5.27431 2.74375L6.0054 4.05969C6.46327 3.86047 6.96877 3.75 7.5 3.75C9.57105 3.75 11.25 5.42894 11.25 7.5H9L11.1151 11.3071ZM9.7257 12.2563L8.9946 10.9403C8.53673 11.1395 8.03123 11.25 7.5 11.25C5.42894 11.25 3.75 9.57105 3.75 7.5H6L3.88495 3.6929C2.87789 4.64947 2.25 6.00142 2.25 7.5C2.25 10.3995 4.60051 12.75 7.5 12.75C8.29568 12.75 9.04995 12.573 9.7257 12.2563Z",
    fill: "#D69517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadDeviceIcon);
export default __webpack_public_path__ + "static/media/loadDeviceIcon.6bf3a0e3.svg";
export { ForwardRef as ReactComponent };